import React from "react";
import { z } from "zod";
import styled from "styled-components";
import { Blade } from "../../../components/Blade";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { AnalyticsProvider } from "../../../providers/AnalyticsProvider";
import { BladeContent } from "../../../components/BladeContent";
import { ArticlePromoCard } from "./ArticlePromoCard";
import { MediaPromosListBladeSchema } from "../../../schemas/blades/MediaPromosList";
import { getValidLayout } from "../../../functional/layouts";
export const ArticlePromoCardLayout = {
    arWide: "arWide",
    arLandscape: "arLandscape",
    arSquare: "arSquare",
    arPortrait: "arPortrait",
};
export const ArticlePromoCardGridPropsSchema = MediaPromosListBladeSchema;
export const ArticlePromoCardGridContractSchema = ArticlePromoCardGridPropsSchema.extend({
    type: z.literal("articlePromoCardGrid"),
});
export const Grid = styled.div ``;
const _ArticlePromoCardGrid = ({ layout, items, ...props }) => {
    const validLayout = getValidLayout(ArticlePromoCardLayout, layout, ArticlePromoCardLayout.arWide);
    return (React.createElement(Blade, { "data-testid": "article-promo-card-grid", ...props },
        React.createElement(AnalyticsProvider, { uiLocation: "grid" },
            React.createElement(BladeContent, { width: "medium" },
                React.createElement(Grid, null, items.map((item, index) => {
                    return React.createElement(ArticlePromoCard, { layout: validLayout, mediaPromoItem: item, key: index });
                }))))));
};
export const ArticlePromoCardGrid = styled(_ArticlePromoCardGrid) `
  ${Grid} {
    ${({ items }) => {
    const fourColumns = items.length === 4;
    return `
      --article-promo-card-grid-flex-basis: ${fourColumns ? "23%" : "30%"};
      --article-promo-card-grid-max-width: ${fourColumns ? "23%" : "30%"};`;
}}
  }

  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=ArticlePromoCardGrid.js.map